import React, { useEffect, useState } from 'react';
import { Button, Table } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import * as selectDropdowns from '../../../../components/RequestForms/utils';
import { Owner } from '../../../../models/Owner';
import { updateOwnerInline } from '../api';
import { useMutation } from '@apollo/client';
import { stripTypenames } from '../../../../utils';

export const GridBody = (props: any) => {
  // const [checkAll, setCheckAll] = useState(false);
  let owners = props.data
  const [ selectedRow, setSelectedRow ] = useState<number>(-1)
  const [ selectedOwner, setSelectedOwner ] = useState<Owner>(null)
  const [ newOwner, setNewOwner ] = useState<{id: number, name: string}>(null)
  const [updateOwner] = useMutation(updateOwnerInline)

  useEffect(() => {
    console.log('newwner: ', newOwner)
    console.log('selected: ', JSON.stringify(selectedOwner))
  }, [newOwner, selectedOwner])

  const handleSave = () => {
    updateOwner({
      variables: {
        owner: stripTypenames(selectedOwner), 
        userName: newOwner.name,
        userId: newOwner.id
      }
    })
    .then((res) => {
      console.log('res: ', res)
      window.location.reload()
    })
    .catch((err) => {
      console.log('err: ', err)
    })
  }

  let list = owners.map((item, index) => {
    return (
      <tr key={index}>
        <td
          onClick={() => {
            setSelectedRow(selectedRow !== -1 ? -1 : index);
            setSelectedOwner(item)
            console.log('item: ', item)
          }}>
          
          <a>
            <i className='far fa-edit' />
          </a>
        </td>
        <td>{item.PhysicalOwner}</td>
        <td>{item.Description}</td>
        <td>{props.depts.filter((element) => element.id === item.DepartmentId)[0].Name}</td>

        {index === selectedRow && (
          <td>
            <Typeahead
              id='userName'
              labelKey={(option) => `${option.name}`}
              options={props.users}
              onChange={(e) => (e[0] ? setNewOwner({id: parseFloat(e[0].id), name: e[0].name}) : setNewOwner(null))}
            />
          </td>
        )}
        {index !== selectedRow && <td>{item.userName}</td>}
        {index === selectedRow && (
          <td>
            <Button size='sm' onClick={handleSave}>
              Save
            </Button>
          </td>
        )}
        {index !== selectedRow && <td>{item.userId}</td>}
      </tr>
    );
  });

  return (
    <Table striped bordered hover style={{ textAlign: 'center' }}>
      <thead>
        <tr>
          <th>
            Edit
            {/* <input
              type='checkbox'
              style={{ width: 20, height: 20 }}
              onChange={(event) => {
                setCheckAll(event.target.checked);
              }}
            /> */}
          </th>
          <th>Physical Owner</th>
          <th>Description</th>
          <th>Department</th>
          <th>User Name</th>
          <th>User ID</th>
        </tr>
      </thead>
      <tbody>{list}</tbody>
    </Table>
  );
};
